import React, { useCallback } from 'react';
import { ClientContext, ServicesContext } from '~/services';

export interface ClientSettingsType {
    id: number;
    name: string;
    report_year_settings: {
        attDate: null | string;
        focDate: null | string;
        quaDate: null | string;
    };
}
export interface ReportYearDatesType {
    attDate: null | string | Date;
    focDate: null | string | Date;
    quaDate: null | string | Date;
}
export const useSetReportYearDates = () => {
    const services = React.useContext(ServicesContext);
    const clientContext = React.useContext(ClientContext);

    const setReportYearDates = useCallback(
        async (dates: ReportYearDatesType) => {
            Object.keys(dates).forEach((x: keyof ReportYearDatesType) => {
                if (dates[x] !== null && typeof dates[x] === 'object') {
                    dates[x] = (dates[x] as Date).toISOString().split('T')[0];
                } else if (typeof dates[x] === 'string') {
                    dates[x] = (dates[x] as string).split('T')[0];
                }
            });
            const response = await services.api.call({
                method: 'put',
                url: `/api/clients/${clientContext.client.id}`,
                data: { report_year_settings: dates },
            });
            clientContext.setClient(response.data);
            const result: ClientSettingsType = response.data;
            return result;
        },
        [services.api, clientContext]
    );

    return setReportYearDates;
};
